function Loader({ text = "Loading..." }) {
  return <div className="center muted">{text}</div>;
}

export default Loader;
